var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card fuel-funds__card h-mobile-no-border-radius" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c(
          "table",
          { staticClass: "maincol__table" },
          [
            _vm._m(1),
            _vm._v(" "),
            _vm._l(_vm.credits, function(credit, index) {
              return _c("DigitalPromoCredit", {
                key: index,
                attrs: { credit: credit }
              })
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-footer" }, [
        _c("div", { staticClass: "fuel-funds__card-total" }, [
          _c("span", { staticClass: "fuel-funds__card-total--transactions" }, [
            _vm._v("Total - Used =")
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "fuel-funds__total--amount" }, [
            _vm._v("$" + _vm._s(_vm.creditsTotal))
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h1", { staticClass: "fuel-funds__card-title" }, [_vm._v("Credits")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "tr",
      { staticClass: "table__row table__row--head table__row--head--credits" },
      [
        _c("td", { staticClass: "table__cell table__cell--date" }, [
          _vm._v("Date")
        ]),
        _vm._v(" "),
        _c("td", { staticClass: "table__cell table__cell--amount" }, [
          _vm._v("Amount")
        ]),
        _vm._v(" "),
        _c("td", { staticClass: "table__cell table__cell--amount" }, [
          _vm._v("Used")
        ]),
        _vm._v(" "),
        _c("td", { staticClass: "table__cell table__cell--remaining" }, [
          _vm._v("Remaining")
        ]),
        _vm._v(" "),
        _c("td", { staticClass: "table__cell table__cell--action" })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }